var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Individual") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.666,4C4.666,2.675 5.711,1.6 7,1.6C8.288,1.6 9.333,2.675 9.333,4C9.333,5.325 8.288,6.4 7,6.4C5.711,6.4 4.666,5.325 4.666,4ZM7,-0C4.852,-0 3.111,1.791 3.111,4C3.111,6.209 4.852,8 7,8C9.148,8 10.889,6.209 10.889,4C10.889,1.791 9.148,-0 7,-0ZM3.889,9.6C2.857,9.6 1.868,10.021 1.139,10.772C0.41,11.522 0,12.539 0,13.6L0,15.2C0,15.642 0.348,16 0.778,16C1.207,16 1.556,15.642 1.556,15.2L1.556,13.6C1.556,12.963 1.801,12.353 2.239,11.903C2.677,11.453 3.27,11.2 3.889,11.2L10.111,11.2C10.73,11.2 11.323,11.453 11.761,11.903C12.199,12.353 12.444,12.963 12.444,13.6L12.444,15.2C12.444,15.642 12.793,16 13.222,16C13.652,16 14,15.642 14,15.2L14,13.6C14,12.539 13.59,11.522 12.861,10.772C12.132,10.021 11.142,9.6 10.111,9.6L3.889,9.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/Individual.54adf2334202fee64977c3a05d305302.svg";
export { ForwardRef as ReactComponent };